import styled from "styled-components";
import * as color from "../../../color/index";

export const AlertMessage = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${color.Colors.red};
`;
